var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 2.16683C1.33325 1.70659 1.70635 1.3335 2.16659 1.3335H3.96065C4.36801 1.3335 4.71567 1.62801 4.78264 2.02983L5.39873 5.72639C5.45888 6.08725 5.27663 6.44514 4.94942 6.60875L3.6593 7.2538C4.58955 9.56543 6.43465 11.4105 8.74628 12.3408L9.39134 11.0507C9.55494 10.7234 9.91283 10.5412 10.2737 10.6013L13.9703 11.2174C14.3721 11.2844 14.6666 11.6321 14.6666 12.0394V13.8335C14.6666 14.2937 14.2935 14.6668 13.8333 14.6668H12.1666C6.1835 14.6668 1.33325 9.81658 1.33325 3.8335V2.16683Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon5);
export default __webpack_public_path__ + "static/media/mobile-icon-5.cd56dfc86ef452437ae194223668f4a6.svg";
export { ForwardRef as ReactComponent };